import { useQueryClient } from '@tanstack/react-query'
import { useAblyChannel } from './useAblyChannel.js'
import { DEFAULT_META } from '../data/metaApi.js'
import { rememberTeamUpdate } from '../data/teamUpdateOverrides.js'

/**
 * useTeamUpdateSync — subscribes to `team-update-updated` Ably events
 * and applies each incoming update directly to the React Query cache
 * for meta.teamUpdates[teamId]. No refetch, so no KV propagation delay
 * and no risk of a stale refetch rolling back a recent save.
 *
 * Mount once at the app root.
 */
export function useTeamUpdateSync() {
  const queryClient = useQueryClient()

  useAblyChannel('team-update-updated', (data) => {
    if (!data?.teamId || !data?.entry) return
    const { teamId, entry } = data
    queryClient.setQueryData(['meta'], (prev) => {
      const meta = prev || DEFAULT_META
      return {
        ...meta,
        teamUpdates: {
          ...(meta.teamUpdates || {}),
          [teamId]: entry,
        },
      }
    })
    rememberTeamUpdate(teamId, entry)
  })
}
